import { type Constructor } from '../types';
import { type fabric } from 'fabric';
import trackEvent from '../utils/analytics';
import WhiteboardController from '../controllers/WhiteboardController';

export default function AnalyticsBehaviors(
  Base: Constructor<fabric.Object>
): any {
  return class extends Base {
    constructor() {
      super(...arguments);

      // @ts-expect-error shapeName is declared on subclasses
      const objectType = this.shapeName || this.wireframeName || this.type;
      let attributes = {};

      if (objectType === 'smartRecord') {
        attributes = { 'Record type': this.recordType };
      }

      this.on('created', () => {
        const { controller } = arguments[0];
        if (
          controller instanceof WhiteboardController &&
          controller.sendShapeCreationAnalytics
        ) {
          recordAnalyticsForShapeCreation(objectType, attributes);
        }
      });
    }
  };
}

export function recordAnalyticsForShapeCreation(
  objectType: string,
  extraAnalyticsAttributes: Record<string, any> = {}
) {
  trackEvent('Feature-7198326346420158012', 'User adds whiteboard object', {
    'Object type': objectType,
    ...extraAnalyticsAttributes,
  });
}
